import React from 'react';
import Certification from 'bundles/users/profile/certification';
import Specialties from 'bundles/users/profile/specialties';
import 'bundles/users/profile/index.scss';
import Organization from 'bundles/users/profile/organizations';
import SubSpecialties, { type SubSpecialtyOption, type UserSubSpecialty } from 'bundles/users/profile/sub_specialties';

export default function ParentCompanyUserProfile(props: ParentCompanyUserProfileProps) {
  return (
    <React.Fragment>
      <Certification
        allBrokerCertifications={props.allBrokerCertifications}
        pcUser={true}
        showCertificationsOnBrokerPlugin={false}
        showCertificationsOnDocuments={false}
        showCertificationsOnEmails={false}
        showCertificationsOnInventoryPlugin={false}
        userCertifications={props.userCertifications}
      />
      <Specialties
        allBrokerSpecialties={props.allBrokerSpecialties}
        pcUser={true}
        showSpecialtiesOnBrokerPlugin={false}
        userSpecialties={props.userSpecialties}
      />
      <SubSpecialties
        allSubSpecialties={props.allSubSpecialties}
        pcUser={true}
        showSubSpecialtiesOnBrokerPlugin={false}
        userSubSpecialties={props.userSubSpecialties}
      />
      <Organization
        allBrokerOrganizations={props.allBrokerOrganizations}
        pcUser={true}
        showOrganizationsOnBrokerPlugin={false}
        userOrganizations={props.userOrganizations}
      />
    </React.Fragment>
  );
}

type ParentCompanyUserProfileProps = {
  allBrokerCertifications: Array<{ id: number, value: number; label: string }>;
  userCertifications: Array<{ value: number; brokerCertificationId: number }>;
  allBrokerSpecialties: Array<{ id: number; title: string }>;
  userSpecialties: Array<{ id: number; brokerSpecialtyId: number }>;
  allSubSpecialties: SubSpecialtyOption[];
  userSubSpecialties: UserSubSpecialty[];
  allBrokerOrganizations: Array<{ value: number; label: string }>;
  userOrganizations: Array<{ value: number; brokerOrganizationId: number }>;
};
